// German catalogue for PipelinePage. Keyed by the English text (src/shared/i18n.ts).
import { registerDe } from '../i18n/index.js';

registerDe({
  'Pipeline': 'Pipeline',
  'seven stages': 'sieben Phasen',
  'a stage change is an event, never an overwrite': 'ein Phasenwechsel ist ein Ereignis, nie eine Überschreibung',
  'a deal without a next step is a fault, not a style': 'ein Geschäft ohne nächsten Schritt ist ein Fehler, kein Stil',
  'New deal': 'Neues Geschäft',

  'Weighted': 'Gewichtet',
  'stage probability × face value': 'Phasenwahrscheinlichkeit × Nennwert',
  'Face value': 'Nennwert',
  '{n} open deals': '{n} offene Geschäfte',
  'Stale deals': 'Stagnierende Geschäfte',
  'past {d}d in stage': 'seit über {d}T in der Phase',
  'past {d}d in stage · {refs}': 'seit über {d}T in der Phase · {refs}',
  'Cycle · 12m': 'Zyklus · 12M',
  'days median': 'Tage Median',
  'lead to signature': 'Lead bis Unterschrift',
  'lead to signature · {n} deals': 'Lead bis Unterschrift · {n} Geschäfte',
  'Win rate · 12m': 'Gewinnrate · 12M',
  '{w} won · {l} lost · loss reasons recorded': '{w} gewonnen · {l} verloren · Verlustgründe erfasst',
  'no won or lost deals in 12 months': 'keine gewonnenen oder verlorenen Geschäfte in 12 Monaten',

  'Open deals': 'Offene Geschäfte',
  'stage is position, left to right': 'die Phase ist eine Position, von links nach rechts',
  'No deals in this stage.': 'Keine Geschäfte in dieser Phase.',
  '{d}d': '{d}T',
  'next:': 'nächster Schritt:',
  'no next step': 'kein nächster Schritt',
  'in Signet': 'in Signet',
  'won on': 'gewonnen am',
  'Move stage →': 'Phase wechseln →',
  'Hand over to Signet →': 'An Signet übergeben →',
  'pending Signet': 'Signet ausstehend',
  '· handover failed': '· Übergabe fehlgeschlagen',

  'Lost · 90d': 'Verloren · 90T',
  'every loss carries a reason and a revisit date': 'jeder Verlust trägt einen Grund und ein Wiedervorlagedatum',
  'No deal has been lost in the last 90 days.': 'In den letzten 90 Tagen wurde kein Geschäft verloren.',
  'lost on': 'verloren am',
  'reason:': 'Grund:',
  'not recorded': 'nicht erfasst',
  'revisit': 'Wiedervorlage',
  'no revisit date set': 'kein Wiedervorlagedatum gesetzt',
  'Create task': 'Aufgabe erstellen',
  'Commitments are not built yet — the interactions agent owns that page.': 'Zusagen sind noch nicht gebaut — diese Seite gehört dem Interaktions-Agenten.',

  'Stage events · latest': 'Phasenereignisse · neueste',
  'append-only': 'nur anfügend',
  'No stage has moved yet.': 'Noch keine Phase hat sich verändert.',
  'opened at {stage}': 'eröffnet bei {stage}',
  '{d}d in {stage}': '{d}T in {stage}',

  'Could not load the pipeline': 'Pipeline konnte nicht geladen werden',

  'Deal': 'Geschäft',
  'Loading…': 'Wird geladen…',
  'Signet': 'Signet',
  'Loss reason': 'Verlustgrund',

  'Organisation': 'Organisation',
  'Type to search organisations…': 'Tippen, um Organisationen zu suchen…',
  'Change': 'Ändern',
  'Title': 'Titel',
  'What is being sold': 'Was verkauft wird',
  'Face value (CHF)': 'Nennwert (CHF)',
  'Probability %': 'Wahrscheinlichkeit %',
  'Next step': 'Nächster Schritt',
  'Next step due': 'Fällig am',
  'Deal created.': 'Geschäft erstellt.',
  'Cancel': 'Abbrechen',
  'Save': 'Speichern',
  'Close': 'Schliessen',

  'Move stage': 'Phase wechseln',
  'From': 'Von',
  'To stage': 'Nach',
  'Reason': 'Grund',
  'Why the deal was lost — this becomes the loss reason': 'Warum das Geschäft verloren wurde — wird zum Verlustgrund',
  'Why this move, in one line': 'Warum dieser Wechsel, in einer Zeile',
  'Quote': 'Zitat',
  'optional': 'optional',
  'A verbatim line from the mail or the call, if there is one': 'Ein wörtliches Zitat aus der Mail oder dem Gespräch, falls vorhanden',
  'Revisit on': 'Wiedervorlage am',
  'Move': 'Wechseln',
  '{ref} moved to {stage}.': '{ref} wurde zu {stage} gewechselt.',

  'Hand over to Signet': 'An Signet übergeben',
  'Client': 'Kunde',
  'Contacts': 'Kontakte',
  'No contact will be sent — the deal has no buying group and no primary person.': 'Es wird kein Kontakt gesendet — das Geschäft hat weder ein Buying-Center noch eine Hauptperson.',
  '(no name)': '(kein Name)',
  'sponsor': 'Sponsor',
  'Engagement': 'Mandat',
  'kickoff': 'Start',
  'Hand over': 'Übergeben',
  'Sending…': 'Wird gesendet…',
  '{ref} handed over to Signet as {code}.': '{ref} an Signet übergeben als {code}.',
  '{ref} written to the Signet outbox — pending until Signet is configured.': '{ref} in den Signet-Ausgang geschrieben — ausstehend, bis Signet konfiguriert ist.',
  'Signet refused the handover.': 'Signet hat die Übergabe abgelehnt.',

  'Lead': 'Lead',
  'Qualified': 'Qualifiziert',
  'Scoping': 'Konzeption',
  'Proposal': 'Angebot',
  'Negotiation': 'Verhandlung',
  'Contracting': 'Vertragsabschluss',
  'Won': 'Gewonnen',
  'Lost': 'Verloren',

  'Buying group': 'Buying-Center',
  'coverage': 'Abdeckung',
  'No buying group mapped yet.': 'Noch kein Buying-Center erfasst.',
  'Add member →': 'Mitglied hinzufügen →',
  'Role': 'Rolle',
  'Stance': 'Haltung',
  'Person': 'Person',
  'Type to search people…': 'Person suchen…',
  'Sponsor': 'Sponsor',
  'Budget owner': 'Budgetverantwortliche·r',
  'IT owner': 'IT-Verantwortliche·r',
  'User': 'Nutzer·in',
  'Procurement': 'Beschaffung',
  'Data protection': 'Datenschutz',
  'Other': 'Andere',
  'Unknown': 'Unbekannt',
  'Champion': 'Fürsprecher·in',
  'Neutral': 'Neutral',
  'Blocker': 'Blockierend',
}, 'PipelinePage');
